module.exports = __webpack_public_path__ + "img/card_img_one.4d881ca3.png";